import { cn } from 'lib/utils';
import { ButtonHTMLAttributes, FC } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'tertiary';
}

const buttonVariants: Record<string, ButtonHTMLAttributes<HTMLButtonElement>['className']> = {
  primary: 'bg-primary-gradient font-bold hover:bg-hover-gradient active:bg-active-gradient',
  secondary:
    'bg-secondary-gradient hover:bg-secondary-gradient font-medium border hover:border border-[rgba(255,255,255,0.3)] hover:border-[rgba(255,255,255,0.3)]',
  tertiary: 'bg-[#333333] hover:bg-[#2d2d2d] font-semibold',
};

export const Button: FC<ButtonProps> = ({ className, variant = 'primary', children, ...props }) => (
  <button
    className={cn(
      'cursor-pointer outline-none flex items-center justify-center px-[22px] py-3 text-primary-white-1 rounded-lg',
      variant && buttonVariants[variant],
      className,
    )}
    {...props}
  >
    {children}
  </button>
);
